import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { Bold, CircleIcon, Paragraph } from '../../Atoms';
import { IconoGmail, IconoWhatsapp } from '../../../Resources/Images/ImagesLogo';
import {
  handleEmailRedirect,
  handleWhatsAppRedirect
} from '../../../Domain/Utils/GeneralFuntions/GeneralFunctions';

export const ConsultantCard = ({ content, justConsultant, nameCourse = '' }) => {
  return (
    <section style={{}} className="d-flex flex-column flex-lg-row py-4">
      <div className="col-12 col-lg-3 d-flex justify-content-center justify-content-lg-start align-items-center">
        <div className="ms-0 w-50 w-lg-75">
          {content?.photo ? (
            <img className="w-100 radius-50" alt="consultant photo" src={content?.photo} />
          ) : (
            <div className="d-flex justify-content-center">
              <FontAwesomeIcon icon={faUser} className="w-50 h-50" />
            </div>
          )}
        </div>
      </div>
      <div className="col-12 col-lg-9 px-md-0 px-3">
        <div className="d-flex flex-wrap justify-content-lg-between justify-content-center text-lg-start mb-4 mt-4 mt-lg-0 text-center">
          <div style={{ fontSize: '18px' }}>
            <Bold size="24px">{`${content?.first_name} ${
              content?.second_name ?? content?.last_name
            }`}</Bold>
            <Paragraph className="lt-card-subtitle">{content?.position}</Paragraph>
          </div>
          <div className="d-flex">
            {justConsultant ? (
              content?.user_datails?.country?.code?.length > 0 && <></>
            ) : (
              <div className="text-black d-flex justify-content-end flex-row gap-4 d-lg-flex d-none">
                <CircleIcon
                  className="pointer"
                  onClick={() => handleEmailRedirect(content?.email)}
                  img={IconoGmail}
                />
                <CircleIcon
                  className="pointer"
                  onClick={() =>
                    handleWhatsAppRedirect(
                      content?.phone?.phone_number,
                      content?.phone?.dial_code,
                      nameCourse
                    )
                  }
                  img={IconoWhatsapp}
                />
              </div>
            )}
          </div>
        </div>
        <Paragraph className="text-lg-start text-center lt-card-subtitle">
          {content.professional_profile}
        </Paragraph>
        {!justConsultant && (
          <div className="text-black d-flex justify-content-center pt-4 gap-4 d-md-flex d-lg-none">
            <CircleIcon
              className="pointer"
              onClick={() => handleEmailRedirect(content?.email)}
              img={IconoGmail}
            />
            <CircleIcon
              className="pointer"
              onClick={() =>
                handleWhatsAppRedirect(
                  content?.phone?.phone_number,
                  content?.phone?.dial_code,
                  nameCourse
                )
              }
              img={IconoWhatsapp}
            />
          </div>
        )}
      </div>
    </section>
  );
};
